import { Space, Switch } from "antd";
import { useIntl } from "react-intl";

type Props = {
  disabled: boolean;
  onChange: (value: boolean) => void;
};

export const EditModeToggle = ({ disabled, onChange }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <Space>
      {formatMessage({ id: "editMode" })}
      <Switch disabled={disabled} onChange={onChange} />
    </Space>
  );
};
